import styled from 'styled-components'
import { VStack } from '../../../global/styles'

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled(VStack)`
  //border: 1px solid red;
`
